// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"navigationitems_NavigationItems__1SXMs"};